import React, { useState } from 'react';
import './ContactMe.css';
import { FaEnvelope, FaLinkedin, FaNewspaper, FaMedium, FaPaperPlane, FaInstagram, FaCheck, FaCopy } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { contactMeData } from '../data/portfolioData';

const ContactMe: React.FC = () => {
  const d = contactMeData;
  const [copied, setCopied] = useState(false);

  const copyEmail = () => {
    navigator.clipboard.writeText(d.email).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="hire-page">
      <div className="hire-hero">
        <h1 className="hire-title">Let's Work Together</h1>
        <p className="hire-subtitle">
          I'm always open to new opportunities, collaborations, and interesting conversations about ML and AI.
        </p>
      </div>

      <div className="hire-grid">
        {/* Email */}
        <div className="hire-card" onClick={copyEmail}>
          <div className="hire-card-icon email-icon">
            <FaEnvelope />
          </div>
          <h3>Email Me</h3>
          <p>{d.email}</p>
          <span className={`hire-card-action ${copied ? 'copied' : ''}`}>
            {copied ? <><FaCheck /> Copied!</> : <><FaCopy /> Copy Email</>}
          </span>
        </div>

        {/* LinkedIn */}
        <a href={d.linkedinLink} target="_blank" rel="noopener noreferrer" className="hire-card">
          <div className="hire-card-icon linkedin-icon">
            <FaLinkedin />
          </div>
          <h3>LinkedIn</h3>
          <p>Let's connect professionally</p>
          <span className="hire-card-action">
            <FaPaperPlane /> View Profile
          </span>
        </a>

        {/* Newsletter */}
        {d.newsletterLink && (
          <a href={d.newsletterLink} target="_blank" rel="noopener noreferrer" className="hire-card">
            <div className="hire-card-icon newsletter-icon">
              <FaNewspaper />
            </div>
            <h3>Newsletter</h3>
            <p>Subscribe to What's Up Dev</p>
            <span className="hire-card-action">
              <FaPaperPlane /> Subscribe
            </span>
          </a>
        )}

        {/* Medium */}
        {d.mediumLink && (
          <a href={d.mediumLink} target="_blank" rel="noopener noreferrer" className="hire-card">
            <div className="hire-card-icon medium-icon">
              <FaMedium />
            </div>
            <h3>Medium</h3>
            <p>Read my articles and insights</p>
            <span className="hire-card-action">
              <FaPaperPlane /> Read Blog
            </span>
          </a>
        )}

        {/* X / Twitter */}
        {d.twitterLink && (
          <a href={d.twitterLink} target="_blank" rel="noopener noreferrer" className="hire-card">
            <div className="hire-card-icon twitter-icon">
              <FaXTwitter />
            </div>
            <h3>X / Twitter</h3>
            <p>Follow me for ML hot takes</p>
            <span className="hire-card-action">
              <FaPaperPlane /> Follow
            </span>
          </a>
        )}

        {/* Instagram */}
        {d.instagramLink && (
          <a href={d.instagramLink} target="_blank" rel="noopener noreferrer" className="hire-card">
            <div className="hire-card-icon instagram-icon">
              <FaInstagram />
            </div>
            <h3>Instagram</h3>
            <p>Behind the scenes</p>
            <span className="hire-card-action">
              <FaPaperPlane /> Follow
            </span>
          </a>
        )}
      </div>
    </div>
  );
};

export default ContactMe;
